module.exports = __webpack_public_path__ + "static/assets/301439e2e5ab88b658368ee525e6752b.svg";